import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { first, Observable, of, switchMap } from "rxjs";
import { selectUserRoles } from "src/app/auth/state/selectors/auth.selectors";
import { User } from "../models/users";
import { WhoisUserService } from '../../auth/services/whois-user.service';

@Injectable({
  providedIn: "root",
})
export class RedirectExceptNativaRoleGuard  {
  private store = inject(Store);
  private router = inject(Router);
  private wis = inject(WhoisUserService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
      if (this.wis.isNativa()) {
        this.router.navigate(["mgmt", "tenants"]);
        return of(false);
      } else {
        return of(true);
      }
    }
}
